import React from "react";
import { format } from "date-fns";
import { ICellRendererParams } from "@ag-grid-community/core";

import { GridTransaction } from "../../../../types";

import TwoLineGridCell from "../TwoLineGridCell";

interface Props extends ICellRendererParams {
  data: GridTransaction;
}

const DateRenderer = ({ data }: Props) => {
  const firstLine = format(new Date(data.completedDate), "MMM d, yyyy");
  const secondLine = format(new Date(data.completedDate), "h:mm a");

  return (
    <TwoLineGridCell firstLineData={firstLine} secondLineData={secondLine} />
  );
};

export default DateRenderer;
